import { render, staticRenderFns } from "./scroll.vue?vue&type=template&id=a23d1a12&scoped=true&"
import script from "./scroll.vue?vue&type=script&lang=ts&"
export * from "./scroll.vue?vue&type=script&lang=ts&"
import style0 from "./scroll.vue?vue&type=style&index=0&id=a23d1a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d1a12",
  null
  
)

export default component.exports